import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RoleList from './RoleList';
import RoleForm from './RoleForm';
import ProtectedRoute from '../../../routes/ProtectedRoutes';

const RoleIndex: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<RoleList />} />
      <Route path="create" element={<RoleForm />} />
      <Route path=":id/edit" element={<RoleForm />} />
      <Route path=":id/view" element={<ProtectedRoute element={<RoleForm viewMode={true} />} />} />
    </Routes>
  );
};

export default RoleIndex;